import { Component, Input } from '@angular/core';

@Component({
  selector: 'base-customer-dashboard-operations',
  templateUrl: './base-customer-dashboard-operations.component.html',
})
export class BaseCustomerDashboardOperationsComponent {
  @Input() active: number;
  @Input() planned: number;
  @Input() isButtonVisible: boolean;
}
